
import { CommonService } from './common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BindComponentService } from '../utils/bind.component.service';
import { ModalReportComponent } from 'app/utils/modals/report/content.component';
import { Injectable } from '@angular/core';
import { Http, ResponseContentType } from '@angular/http';
import { AlertService } from '../utils/alert.service';
/**
 * @version $Id$
 */
@Injectable()
export class ReportDownloadService extends CommonService {
    constructor(public http: Http, public modalService: NgbModal, public bindComponent: BindComponentService, public alertService: AlertService) {
        super(http, modalService, bindComponent);
    }
    public prepare(url: string) {

        this.http.get(url, { responseType: ResponseContentType.ArrayBuffer }).subscribe(data => {
            let headers = data.headers;
            let blob = new Blob([data.arrayBuffer()], { type: headers.get('Content-Type') });
            let cDisposition = headers.get('Content-Disposition') || '';
            let matches = /filename=([^;]+)/ig.exec(cDisposition);
            let fileName = (matches[1] || 'untitled').trim();

            const modal = this.modalService.open(ModalReportComponent);
            const instance = (<ModalReportComponent> modal.componentInstance);
            instance.blobReport = blob;
            instance.fileName = fileName
            modal.result.then(result => {
            }, reason => null);
        });
        this.alertService.success("Geração do relatório em processamento");
    }

}


// WEBPACK FOOTER //
// ./src/app/services/report.download.service.ts